let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kfezh")).then(() => parcelRequire('er7lB'));